import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Button } from '@/components/ui/Button/Button';
import { CheckIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { hotlineClientBulkCancelContentStyle } from '@/feature/hotline/client/detail/negotiate/component/HotlineClientBulkCancelContent/style';
/**
 * ホットライン 一括キャンセル表示
 */
export const HotlineClientBulkCancelContent = (props) => {
    const { className = '', count, onClickButton } = props;
    const style = hotlineClientBulkCancelContentStyle();
    return (_jsxs("div", Object.assign({ className: style.base({ class: className }) }, { children: [_jsxs("div", Object.assign({ className: style.textContentWrap() }, { children: [_jsx(CheckIcon, { color: 'primary', size: 'xs' }), _jsx("span", Object.assign({ className: style.text() }, { children: `${count}社の相談オファーを一括キャンセルする` }))] })), _jsx(Button, Object.assign({ color: 'navy', onClick: onClickButton, size: 'md' }, { children: "\u30AD\u30E3\u30F3\u30BB\u30EB\u7406\u7531\u3092\u5165\u529B" }))] })));
};
